import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutBrokeragePlanningProfileList extends Layout {
    layoutheaderBrokPlanningProfileList: LayoutHeader;
    sourceBrokeragePlanningProfile: DataSource;
    tableSearch: Table;
}
